import BulkActionsController from "controllers/components/bulk_actions_controller"
import {flashMessage} from "../../../helpers/huntressHelpers"

export default class extends BulkActionsController {
  static targets = ["bulkDirListButton", "bulkGetFileButton"]

  connect() {
    super.connect()
  }

  handleToggleSingle(evt) {
    evt.target.checked === true ? this.enableBulkActions() : this.disableBulkActions()

    this.updateSelectedCounter()
    this.updateSelectAllCheckbox()
  }

  enableBulkActions() {
    if (this.hasBulkDirListButtonTarget && $(".bulk-select[data-is-dir=\"True\"]:not(:disabled):checked", this.rootElement).length > 0) {
      $(this.bulkDirListButtonTarget).removeClass("disabled").attr("disabled", false)
    }

    if (this.hasBulkGetFileButtonTarget && $(".bulk-select[data-is-dir=\"False\"]:not(:disabled):checked", this.rootElement).length > 0) {
      $(this.bulkGetFileButtonTarget).removeClass("disabled").attr("disabled", false)
    }
  }

  disableBulkActions() {
    if (this.hasBulkDirListButtonTarget && $(".bulk-select[data-is-dir=\"True\"]:not(:disabled):checked", this.rootElement).length === 0) {
      $(this.bulkDirListButtonTarget, this.rootElement).addClass("disabled").attr("disabled", true)
    }

    if (this.hasBulkGetFileButtonTarget && $(".bulk-select[data-is-dir=\"False\"]:not(:disabled):checked", this.rootElement).length === 0) {
      $(this.bulkGetFileButtonTarget).addClass("disabled").attr("disabled", true)
    }
  }

  createDirListTasks(evt) {
    this.createMultipleTasks(evt.target.dataset.url, "dir_list", "Bulk Create DirList", ".bulk-select[data-is-dir=\"True\"]:not(:disabled):checked")
  }

  createGetFileTasks(evt) {
    this.createMultipleTasks(evt.target.dataset.url, "get_file", "Bulk Create GetFile", ".bulk-select[data-is-dir=\"False\"]:not(:disabled):checked")
  }

  createMultipleTasks(url, taskType, bulkTaskName, checkboxSelector) {
    let params = {
      type: taskType,
    }

    params[taskType] = {
      bulk_task_name: bulkTaskName,
      tasks: []
    }

    $(checkboxSelector, this.rootElement).each((_index, checkbox) => {
      params[taskType]["tasks"].push(JSON.parse(checkbox.dataset.taskParams))
    })

    $.ajax({
      url: url,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify(params),
      success: ()=> {
        location.reload()
      },
      error: () => {
        flashMessage("Unable to create tasks, please try again later.", "warning", this.element, true)
      }
    })
  }
}
